<script setup>
import { useNavigationStore } from '~/stores/navigationStore'
import { useI18n } from 'vue-i18n'
import { config as constants, routes } from '~/config/constants'

const config = useRuntimeConfig()
const { t } = useI18n()
const store = useNavigationStore()

const { step } = storeToRefs(store)

const getButtonTitle = (currentStep) => {
    switch (currentStep) {
    case -1:
    case 0:
    case 5:
        return t('progress.home')
    default:
        return t('progress.backToStep', { step: currentStep })
    }
}

const getButtonLink = (currentStep) => {
    switch (currentStep) {
    case -1:
    case 0:
    case 5:
        return constants.webSiteUrl
    default:
        return routes[currentStep - 1].url
    }
}
</script>

<template>
    <va-alert
        v-if="config.public.test_env === 'production'"
        color="danger"
        icon="warning"
        class="text-center mb-5"
    >
        Let op, deze omgeving maakt gebruik van <strong>Productie</strong> gegevens!
    </va-alert>
    <va-alert
        v-if="config.public.disabled"
        color="danger"
        icon="warning"
        class="text-center"
    >
        Helaas is het vanwege een storing op dit moment niet mogelijk om via onze website tickets te reserveren. Neem
        telefonisch contact met ons op voor het reserveren van tickets: <a href="tel:0242001050">024 - 200 10 50</a>.
        Onze excuses voor het ongemak.
    </va-alert>
    <div class="layout">
        <va-navbar color="background-primary">
            <template #left>
                <va-navbar-item class="logo">
                    <img
                        src="~/assets/img/muzieum-logo.svg"
                        :alt="config.public.siteName"
                    >
                </va-navbar-item>
            </template>
            <template #right>
                <va-navbar-item>
                    <va-button
                        class="primary hide-mobile"
                        round
                        icon="arrow_back"
                        :to="getButtonLink(step)"
                    >
                        {{ getButtonTitle(step) }}
                    </va-button>
                </va-navbar-item>
            </template>
        </va-navbar>
    </div>
    <ProgressSteps v-if="step >= 0" />
</template>
